import { useContextState } from "../../../../../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()
  return {
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom:3,
      '& .gp1':{
        gap:1
      }
    },
    section: {
      marginBottom: '32px',
    },
    clean: {
      '&.MuiIconButton-root': {
        fontSize: '1rem',
        '& .MuiSvgIcon-root': {
          fontSize: '1em',
        },
      },
    },
    hide: {
      visibility: 'hidden',
    },
    filter: {
      fontSize: '16px',
      fontWeight: '600',
      color: colors.color13,
      marginBottom: 2
    }
  }
}

export { useStyles }
